import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { UserService } from "./user.service";

/**
 * Keeps unfinished-onboarding sessions on /onboarding for every navigation, not just the
 * one right after login (login.component.routeAfterLogin only redirects once). Without
 * this, a user with onboardingComplete === false who reloads or deep-links straight to an
 * authenticated route lands on it with the side-nav/bottom-nav hidden (app.component's
 * showNav also checks isOnboardingComplete) but no redirect to actually finish onboarding.
 */
@Injectable()
export class OnboardingGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private userService: UserService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.userService.isOnboardingComplete()) {
      this.router.navigate(["/onboarding"]);
      return false;
    }

    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(childRoute, state);
  }
}
